//USING REALTIME DATABASE https://console.firebase.google.com/u/0/project/jankdwhispers/database/jankdwhispers-default-rtdb/data/~2F in singapore

//default is only authenticated users can read or write 

//HIDE DEETS IN GITIGNORE SECURITY RISK!!!

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCH06qVpPIdKpM_dYCAWWeA5gmiJ2rEXtE",
  authDomain: "jankdwhispers.firebaseapp.com",
  databaseURL: "https://jankapp-secrets-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: "jankdwhispers",
  storageBucket: "jankdwhispers.firebasestorage.app",
  messagingSenderId: "686052614308",
  appId: "1:686052614308:web:209d3204e36d02f645c631",
  measurementId: "G-SKT9Q9244X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getDatabase(app);






/*// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration >> maybe hide further w .env 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDL5Mi8HZjzEzSf8KIJm69cPdIY1Vvf0PA",
  authDomain: "jankapp-secrets.firebaseapp.com",
  projectId: "jankapp-secrets",
  storageBucket: "jankapp-secrets.firebasestorage.app",
  messagingSenderId: "525748242410",
  appId: "1:525748242410:web:42ece46e7042f06b665493",
  measurementId: "G-BSYB595KV7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);*/